<!--<h4>Calendar</h4>-->
    <p>
        The MBA Bidding widget displays information on upcoming or in-progress bidding rounds. UNC Kenan-Flagler bidding takes place in the <a routerLink="/catalog">MyKE Course Catalog</a> pages for the full-time MBA program.
    </p>
